import { Center, Input, InputGroup } from '@chakra-ui/react';
import { SearchIcon } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

interface SearchFieldProps {
  searchValue: string;
  onChange: (value: string) => void;
}

const SearchField = ({ searchValue, onChange }: SearchFieldProps) => {
  const { t } = useTranslation();
  return (
    <InputGroup
      startElement={
        <Center flexShrink="0" fontSize="md">
          <SearchIcon />
        </Center>
      }
      mb="2"
    >
      <Input
        value={searchValue}
        placeholder={t('filter.searchPlaceholder')}
        borderRadius="lg"
        h="2.57em"
        onChange={(e) => onChange(e.target.value)}
      />
    </InputGroup>
  );
};

const MemoizedSearchField = memo(SearchField);

export { MemoizedSearchField as SearchField };
